import { formatPics, filterParams } from '@/common/utils/format'

import { get } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'



export function revert (data = {}) {
  const city = get(data, 'bizGlobal.docInfo.city')
  if (!city) return {}
  return {
    licensePics: formatPics(city.licensePics),
    files: formatPics(city.files)
  }
}

export function submitFormat (cityInfo) {
  return {
    params: JSON.stringify({
      source: 'contractor',
      queryId: this.$route.params.id,
      bizGlobal: {
        ...cityInfo.bizGlobal,
        country: country
      }
    })
  }
}

export default {
  revert,
  submitFormat
}
